<script lang="ts">
  const fonts: [googName: string, name: string][] = [
    ['Acme', 'Acme'],
    ['Audiowide', 'Audiowide'],
    ['Bangers', 'Bangers'],
    ['Barrio', 'Barrio'],
    ['Bebas+Neue', 'BebasNeue'],
    ['Bungee', 'Bungee'],
    ['Bungee+Outline', 'Bungee Outline'],
    ['Cabin+Sketch', 'CabinSketch'],
    ['Caesar+Dressing', 'Caesar Dressing'],
    ['Chakra+Petch', 'Chakra Petch'],
    ['Cinzel+Decorative', 'Cinzel Decorative'],
    ['Codystar', 'Codystar'],
    ['Comic+Neue', 'ComicNeue'],
    ['Courier+Prime', 'Courier Prime'],
    ['Creepster', 'Creepster'],
    ['FredokavOne', 'FredokaOne'],
    ['Gorditas', 'Gorditas'],
    ['Grape+Nuts', 'Grape Nuts'],
    ['HennyvPenny', 'Henny Penny'],
    ['IM+Fell+English', 'IM Fell English'],
    ['Inconsolata', 'Inconsolata'],
    ['Josefin+Sans', 'Josefin Sans'],
    ['Jost', 'Jost'],
    ['Julius+Sans+One', 'Julius Sans One'],
    ['Limelight', 'Limelight'],
    ['Londrina+Outline', 'Londrina Outline'],
    ['Major+Mono+Display', 'Major Mono Display'],
    ['Merriweather', 'Merriweather'],
    ['Michroma', 'Michroma'],
    ['Mochiy+Pop+One', 'Mochiy Pop One'],
    ['Monoton', 'Monoton'],
    ['Montserrat+Alternates', 'Montserrat Alternates'],
    ['MuseoModerno', 'MuseoModerno'],
    ['Orbitron', 'Orbitron'],
    ['PiratavOne', 'PirataOne'],
    ['Poiret+One', 'Poiret One'],
    ['Press+Start+2P+', 'PressStart2P'],
    ['Rubik+Glitch', 'Rubik Glitch'],
    ['Rubik+Moonrocks', 'Rubik Moonrocks'],
    ['Sancreek', 'Sancreek'],
    ['Sigmar+One', 'Sigmar One'],
    ['Special+Elite', 'Special Elite'],
    ['Stick', 'Stick'],
    ['Train+One', 'Train One'],
    ['UnifrakturMaguntia', 'UnifrakturMaguntia'],
    ['VT323', 'VT323'],
  ];

  function fontLicenenceUrl(name: string) {
    const url = new URL(`/specimen/${name}`, 'https://fonts.google.com/');
    url.hash = 'license';
    return url.href;
  }
</script>

<div class="container">
  <h1>incident.day</h1>

  <div>
    <a href="/">Back</a>
  </div>

  <h2>About</h2>

  <p>
    A hobby project by <a href="https://twitter.com/runeh">Rune</a>
    (<a href="mailto:incident-day@runefh.dev">mail</a>)
  </p>

  <h2>Licenses</h2>

  The following fonts are licensed under the{' '}<a
    href="https://opensource.org/licenses/OFL-1.1">Open Font License</a
  >:

  <ol>
    {#each fonts as [googName, name]}
      <li>
        <a href={fontLicenenceUrl(googName)}>{name}</a>
      </li>
    {/each}
  </ol>

  The
  <a href="https://feathericons.com">Feather icon set</a> is licensed under the
  <a href="https://github.com/feathericons/feather/blob/master/LICENSE"
    >MIT license</a
  >.
</div>

<style>
  .container {
    max-width: 650px;
    margin: auto;
  }

  h1 {
    font-size: 90px;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  ol {
    list-style: none;
    padding-left: 0;
  }

  li {
    display: inline-block;
    width: 200px;
  }
</style>
